import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject, ReplaySubject } from 'rxjs';

@Injectable()
export class AppToastService {
  private subSuccess: Subject<any>;
  private subError: Subject<any>;
  private subWarning: Subject<any>;
  private subInfo: Subject<any>;
  private subBlockDocument: ReplaySubject<boolean>;

  subSuccessCalled$: Observable<any>;
  subErrorCalled$: Observable<any>;
  subWarningCalled$: Observable<any>;
  subInfoCalled$: Observable<any>;
  subBlockDocumentCalled$: Observable<boolean>;

  constructor() {
    this.subSuccess = new Subject<any>();
    this.subError = new Subject<any>();
    this.subWarning = new Subject<any>();
    this.subInfo = new Subject<any>();
    this.subBlockDocument = new ReplaySubject<boolean>();

    this.subSuccessCalled$ = this.subSuccess.asObservable();
    this.subErrorCalled$ = this.subError.asObservable();
    this.subWarningCalled$ = this.subWarning.asObservable();
    this.subInfoCalled$ = this.subInfo.asObservable();
    this.subBlockDocumentCalled$ = this.subBlockDocument.asObservable();
  }

  success(summary?: string, detail?: string, sticky: boolean = false, lifeTime: number = 10000) {
    this.subSuccess.next({ summary, detail, sticky, lifeTime });
  }

  error(summary?: string, detail?: string, sticky: boolean = false, lifeTime: number = 10000) {
    this.subError.next({ summary, detail, sticky, lifeTime });
  }

  warning(summary?: string, detail?: string, sticky: boolean = false, lifeTime: number = 10000) {
    this.subWarning.next({ summary, detail, sticky, lifeTime });
  }

  info(summary?: string, detail?: string, sticky: boolean = false, lifeTime: number = 10000) {
    this.subInfo.next({ summary, detail, sticky, lifeTime });
  }

  blockDocument(blocked: boolean = false) {
    this.subBlockDocument.next(blocked);
  }

}
